<template>
  <!-- componente global para modais -->
  <!-- TODO: rever fluxo para tentar facilitar uso -->
  <div class="ModalGlobal">
    <!--
     titulo e tamanho dos modais são pegos pelo @onGetConfig="(config) => getConfigModal(config)"

     MODAL CHAMADO ATRAVÉS DE:
     window.modalGlobal.show(action, data)
     onde "action" define o conteúdo que será mostrado e "data" os dados que serão passados para a propData do conteudo

     Ex:
     window.modalGlobal.show('certificados') (@/helpers/Bry.js)
     -->
    <b-modal v-show="modal.show"
             id="modal-global"
             ref="modal-global"
             :title="modal.title"
             :size="modal.size"
             hide-footer>
      <!-- area que entrará os conteúdos -->
      <!-- ATENÇÃO! os components devem conter apenas o conteúdo e não outro "b-modal" -->
      <div>
        <!-- modal de CERTIFICADOS -->
        <modal-global-certificados v-if="modal.action == 'certificados'"
                                   :prop-data="modal.data"
                                   @onGetConfig="(config) => getConfigModal(config)" />
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import ModalGlobalCertificados from '@/components/ModalGlobal/ModalGlobalCertificados'

  export default {
    name: "ComponentGlobal",
    components: {
      ModalGlobalCertificados
    },
    data () {
      return {
        modal: {
          title: null, // titulo do modal
          size: 'md', // tamanho do modal
          data: null,
          action: null, // define qual conteudo aparecerá no modal
          show: false
        }
      }
    },
    computed: {
      assinaturasComp () {
        if (this.data && this.certificadoSelecionado) {
          return this.data.filter(assinatura => assinatura.cpf == this.certificadoSelecionado.cpf)
        } else if (this.data) {
          return this.data
        }
        return []
      }
    },
    mounted () {
      this.$root.$on('bv::modal::show', (bvEvent) => {
        // verificando se existe dados para o modal
        this.$root.$on('sofia::modalGlobal::data', (infoModal) => {
          const  { action, data } = infoModal

          this.modal.action = action
          this.modal.data = data
        })
      })

      this.$root.$on('bv::modal::hide', () => {
        this.modal.show = false
        this.reset()
      })
    },
    methods: {
      // funcao que pega informacoes sobre o modal
      getConfigModal (config) {
        Object.assign(this.modal, config)
        this.modal.show = true
      },
      reset  () {
        this.certificados = []
        this.certificadoSelecionado = null

        // resetando config modal
        this.modal = {
          title: null, // titulo do modal
          size: null, // tamanho do modal
          data: null,
          action: null, // define qual conteudo aparecerá no modal
          show: false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../scss/_utilities/_exports';

  .ModalGlobal {
    &--card {
      border: 1px solid $color-gray-light;
      margin-bottom: 5px;
    }

    &--header {
      background-color: $color-gray-light;
      padding: 5px 5px;
      height: 33px;
      cursor: pointer;
    }

    &--body {
      padding: 5px 5px;
    }
  }
</style>
